import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LoadingSkeletonComponent } from '@shared/components/loading-skeleton';
import { LoadingSkeletonBaseClass } from '@shared/components/loading-skeleton-base-class';
import { SiteAtAGlanceLoadingSkeletonComponent } from '@shared/components/site-at-a-glance-loading-skeleton';
import { WhitePanelComponent } from '@shared/components/white-panel/white-panel.component';

@Component({
  selector: 'app-at-a-glance-site-card-loading-skeleton',
  imports: [LoadingSkeletonComponent, WhitePanelComponent, SiteAtAGlanceLoadingSkeletonComponent],
  templateUrl: './at-a-glance-site-card-loading-skeleton.component.html',
  host: {
    class: 'flex flex-col',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AtAGlanceSiteCardLoadingSkeletonComponent extends LoadingSkeletonBaseClass {}
